// Session management constants

// LocalStorage key for active session IDs
export const ACTIVE_SESSION_IDS = 'reel_active_session_ids';

// LocalStorage key for currently uploading session ID
export const UPLOADING_SESSION_ID = 'reel_uploading_session_id';

// Default device ID value for unknown users
export const UNKNOWN_DEVICE_ID = 'unknown_device';

// LocalStorage key for uploading flag
export const LOCAL_UPLOADING_FLAG = 'reel_uploading_flag_2.0.2';
